import { F } from 'cc-context-switcher'

import { history } from '../../../redux/store'

export const contextSwitchRedirect: typeof F = (to): void => {
  history.replace(to, { noPrompt: true })
}

export default contextSwitchRedirect
